import React from 'react';

interface Props {
  children: React.ReactNode;
  tall: boolean;
  isBlurred?: boolean;
}

export const WorkContainer: React.FC<Props> = ({
  children,
  tall,
  isBlurred,
}) => (
  <div className="wp-card__spacer">
    <div className="wp-card__container">
      <div className="wp-card wp-workCard">
        <div
          className={
            (tall
              ? 'wp-workCard_tallItemContainer'
              : 'wp-workCard_itemContainer') +
            (isBlurred ? ' wp-workCard_blurredItemContainer' : '') +
            ' responsive_margins'
          }
        >
          {children}
        </div>
      </div>
    </div>
  </div>
);
